import { render, staticRenderFns } from "./ModalCreateHoiChanTQM.vue?vue&type=template&id=1b8ae970&scoped=true"
import script from "./ModalCreateHoiChanTQM.vue?vue&type=script&lang=js"
export * from "./ModalCreateHoiChanTQM.vue?vue&type=script&lang=js"
import style0 from "./ModalCreateHoiChanTQM.vue?vue&type=style&index=0&id=1b8ae970&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8ae970",
  null
  
)

export default component.exports